export default function OpenSubList() {
  const arrows = document.querySelectorAll(
    ".table-of-content-wrapper .sub-list-arrow",
  );

  if (!arrows.length) return;

  arrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const subList = arrow.parentElement.querySelector(".sub-list");

      if (!subList || subList.classList.contains("sliding")) return;

      const isOpen = subList.classList.contains("open");

      subList.classList.add("sliding");
      arrow.classList.toggle("open");

      if (!isOpen) {
        // Open
        subList.classList.add("open");
        subList.style.display = "block";
        subList.style.overflow = "hidden";
        subList.style.height = "0px";

        // Force reflow
        subList.offsetHeight;

        subList.style.transition = "height 300ms ease";
        subList.style.height = `${subList.scrollHeight}px`;

        subList.addEventListener(
          "transitionend",
          () => {
            subList.style.removeProperty("height");
            subList.style.removeProperty("overflow");
            subList.style.removeProperty("transition");
            subList.classList.remove("sliding");
          },
          { once: true },
        );
      } else {
        // Close
        subList.style.height = `${subList.scrollHeight}px`;
        subList.style.overflow = "hidden";

        // Force reflow
        subList.offsetHeight;

        subList.style.transition = "height 300ms ease";
        subList.style.height = "0px";

        subList.addEventListener(
          "transitionend",
          () => {
            subList.classList.remove("open");
            subList.style.display = "none";
            subList.style.removeProperty("height");
            subList.style.removeProperty("overflow");
            subList.style.removeProperty("transition");
            subList.classList.remove("sliding");
          },
          { once: true },
        );
      }
    });
  });
}
